import { BACKEND_URI } from "../entries"
import { secureAPICall } from "../utils/sessionUtils"


export const requestFetchServerStatus = ({ verbose = false }) => {
    return secureAPICall({ endpoint: BACKEND_URI + "/api/system/fetch-server-status", verbose: verbose })
}